import { createAPI } from "./api/api";

const api = createAPI();

let matchesAbortController;

export const getMatches = async (
  name,
  activeBlock,
  setIsMatchesLoading,
  queryParams,
  setMatches,
  setQueryParams,
  id
) => {
  if (id === null) {
    setMatches([]);
    setIsMatchesLoading(false);
    if (matchesAbortController) {
      matchesAbortController.abort();
    }
    return;
  }

  if (matchesAbortController) {
    matchesAbortController.abort();
  }

  matchesAbortController = new AbortController();
  const { signal } = matchesAbortController;

  const newParams = new URLSearchParams(queryParams);
  newParams.set(activeBlock.toLowerCase(), name);

  const getMatchParams = () => {
    if (id) {
      return `&id_selected=${id}`;
    } else return "";
  };

  try {
    setIsMatchesLoading(true);
    setQueryParams(newParams);

    const res = await api.get(
      `/me/identities_matches/params?${newParams.toString()}${getMatchParams()}`,
      { signal }
    );

    if (res.data !== null) {
      setMatches(res.data);
    } else {
      setMatches([]);
    }
  } catch (error) {
    if (error.name === "AbortError") {
      console.log("Request cancelled:", error.response.data.message);
    } else {
      console.log("Error of getting identity matches:", error);
      setMatches([]);
    }
  } finally {
    if (matchesAbortController.signal === signal) {
      setIsMatchesLoading(false);
    }
  }
};

export const refreshMatches = async (
  params,
  setMatches,
  setIsMatchesLoading,
  firstSelectedCard,
) => {
  if (params === null) {
    setMatches([]);
    setIsMatchesLoading(false);
    if (matchesAbortController) {
      matchesAbortController.abort();
    }
    return;
  }

  if (matchesAbortController) {
    matchesAbortController.abort();
  }

  matchesAbortController = new AbortController();
  const { signal } = matchesAbortController;

  const getMatchParams = () => {
    if (firstSelectedCard !== null) {
      return `&id_selected=${firstSelectedCard.id}`;
    } else return "";
  };

  try {
    setIsMatchesLoading(true);

    const res = await api.get(
      `/me/identities_matches/params?${params.toString()}${getMatchParams()}`,
      { signal }
    );
    if (res.data !== null) {
      setMatches(res.data);
    } else {
      setMatches([]);
    }
  } catch (error) {
    if (error.name === "AbortError") {
      console.log("Request cancelled");
    } else {
      console.log("Error refreshing matches:", error);
      setMatches([]);
    }
  } finally {
    if (matchesAbortController.signal === signal) {
      setIsMatchesLoading(false);
    }
  }
};

let getCurrentDataAbortController;

export const getCurrentData = (
  resetCards,
  getDataSubUrl,
  activeBlock,
  getFiltersParams,
  activeFilters,
  offsetCount,
  getCurrentOrder,
  setSelectCards,
  setPaginationData,
  search,
  matchParams,
  showOnboardingCards
) => {
  if (getCurrentDataAbortController) {
    getCurrentDataAbortController.abort();
  }

  getCurrentDataAbortController = new AbortController();
  const signal = getCurrentDataAbortController.signal;

  const params = new URLSearchParams(search);
  const searchParams = params.get("search")
    ? `&search=${params.get("search")}`
    : "";

  resetCards();
  api
    .get(
      `/me/nft_card_${getDataSubUrl(activeBlock)}/params?${getFiltersParams(
        activeFilters
      )}&limit=50&offset=${offsetCount}&type=${activeBlock.toLowerCase()}&order=${getCurrentOrder()}${searchParams}${matchParams}${showOnboardingCards ? '&show_onboarding=true' : ''}`,
      { signal }
    )
    .then((response) => {
      setSelectCards(response.data.data);
      setPaginationData(response.data.pagination_metadata);
    })
    .catch((error) => {
      if (error.name === "AbortError") {
        console.log("Запрос был отменен");
      } else {
        console.log('craft Identity getCurrentData', error.response);
        setSelectCards([]);
        setPaginationData({});
      }
    });
};

let identityFiltersController = null;

export const getIdentityFilters = (activeBlock, setFilters) => {

  if (identityFiltersController) {
    identityFiltersController.abort();
    identityFiltersController = null;
  }

  identityFiltersController = new AbortController();
  const signal = identityFiltersController.signal;

  if (activeBlock !== "Category") {
    api
      .get(`/me/list_filters/params?type=dates`, {signal})
      .then((res) => setFilters(res.data.data.slice(1)))
      .catch((error) => console.log(error));
  } else {
    api
      .get(`/me/list_filters/params?type=categories`, {signal})
      .then((res) => setFilters(res.data.data))
      .catch((error) => console.log(error));
  }
};
